<template>
    <app-layout title="Edit Customer Credit Card">
        <form @submit.prevent="submit">
            <page-header>
                <template #title>Edit Customer Credit Card</template>

                <template #actions>
                    <!-- <jet-button v-show="form.isDirty" type="submit" class="h-7 leading-none" :disabled="form.processing" > -->
                    <jet-button type="submit" class="h-7 leading-none" :disabled="form.processing" >
                        Save
                    </jet-button>

                    <!-- <jet-tertiary-button class="h-7 leading-none" :disabled="form.processing" :href="route('customers.index')"> -->
                    <jet-tertiary-button class="h-7 leading-none" :href="route('customers.card_vault', customerId)">
                        {{ form.isDirty ? 'Cancel' : 'Close' }}
                    </jet-tertiary-button>
                </template>
            </page-header>

            <div class="px-8 xl:flex">
                <card-vault-form 
                    :form="form"
                    :customerVault="customerVault"
                />
            </div>
        </form>
    </app-layout>
</template>

<script>
import { useForm } from '@inertiajs/inertia-vue3';
import JetButton from '@/Jetstream/Button';
import JetTertiaryButton from '@/Jetstream/TertiaryButton';
import AppLayout from '@/Layouts/AppLayout.vue';
import PageHeader from '@/Layouts/partials/PageHeader.vue';
import CardVaultForm from '@/Pages/Customer/Partials/CardVaultForm.vue';

import '@vueform/multiselect/themes/default.css';
import '@vueform/toggle/themes/default.css';

export default {
    setup(props) {
        const form = useForm({
            id: props.customerVault.id,
            street_number: props.customerVault.street_number,
            street_name: props.customerVault.street_name,
            postal: props.customerVault.postal,
            last_four: props.customerVault.last_four,
            expiry: props.customerVault.expiry,
            cvd: null,
            brand: props.customerVault.brand,
            city: props.customerVault.city,
            province: props.customerVault.province,
            first_name: props.customerVault.first_name,
            last_name: props.customerVault.last_name,
            phone: props.customerVault.phone,
        })
        
        return { form }
    },

    components: {
        AppLayout,
        PageHeader,
        JetButton,
        JetTertiaryButton,
        CardVaultForm
    },

    props: [
        'customerVault',
        'customerId',
    ],

    data() {
        return {
            formRoute: this.route('customers.card_vault.update', this.customerVault.id),
        }
    },

    computed: {
        backUrl () {
            return route('customers.card_vault', {
                page: this.$page.props.page.customerId,
            });
        }
    },

    methods: {
        submit() {
            this.form.post(route('customers.card_vault.update', this.customerVault.id));
        },
    },
}
</script>

<style scoped>

</style>
